import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EquipmentType } from './../../../common/equipment.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppServerAPI, DetailLayout } from '@sdbn/common';

@Component({
  selector: 'app-equipment-admin-details',
  templateUrl: './equipment-admin-details.component.html',
  styleUrls: ['./equipment-admin-details.component.scss']
})
export class EquipmentAdminDetailsComponent implements OnInit {

  equipmentType: EquipmentType;

  formGroup = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    description: new FormControl(null, []),
    requiresTakeback: new FormControl(false, []),
    manageInstances: new FormControl(false, []),
    disabled: new FormControl(false, [])
  })

  updating = false;

  @Input('equipmentType') set setEquipmentType(value: EquipmentType) {
    this.equipmentType = value;
    if (this.equipmentType != null) {
      console.log('processing type', value);
      this.updating = true;
      this.setDetailsToForm();
      this.updating = false;
    }
  }

  @Output() changed = new EventEmitter<void>();

  @Output() canceled = new EventEmitter<void>();

  constructor(
    private appServerAPI: AppServerAPI
  ) { }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {

      if (this.updating || this.equipmentType == null) {
        return;
      }

      this.equipmentType.name = value.name;
      this.equipmentType.description = value.description;
      this.equipmentType.requiresTakeback = value.requiresTakeback;
      this.equipmentType.manageInstances = value.manageInstances;
      this.equipmentType.disabled = value.disabled;
    });

  }

  private setDetailsToForm() {
    this.formGroup.patchValue({
      name: this.equipmentType?.name,
      description: this.equipmentType?.description,
      requiresTakeback: this.equipmentType?.requiresTakeback,
      manageInstances: this.equipmentType?.manageInstances,
      disabled: this.equipmentType?.disabled
    });
  }

  public save() {
    this.appServerAPI.execute('/tmc-common/equipment/save', this.equipmentType).subscribe(response => {
      this.changed.emit();
    });
  }

  public cancel() {
    this.canceled.emit();
  }

  public onChange(layout: DetailLayout) {
    this.equipmentType.attributeDefinition = JSON.stringify(layout);
  }

}
